import React, { useEffect, useState } from 'react';
import { BarChart3, Eye, Users, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { useAuth } from '../../contexts/AuthContext';
import { sectionLabel } from './SectionOrderCard';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Stat = ({ icon: Icon, label, value, testId }) => (
  <div className="bg-slate-50 border border-slate-200 rounded-lg p-3" data-testid={testId}>
    <p className="text-xs text-slate-500 flex items-center gap-1"><Icon className="h-3.5 w-3.5" />{label}</p>
    <p className="text-xl font-semibold text-slate-900">{value}</p>
  </div>
);

export const GuidebookStatsCard = ({ propertyId, gb }) => {
  const { token } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/admin/guidebook/${propertyId}/stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null)).then(setStats).catch(() => setStats(null));
  }, [propertyId, token]);

  const max = stats?.sections?.[0]?.count || 1;

  return (
    <Card data-testid="gb-stats-card">
      <CardHeader className="pb-3"><CardTitle className="text-base flex items-center gap-2"><BarChart3 className="h-4 w-4 text-amber-500" />Guest engagement</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        {!stats ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : (
          <>
            <div className="grid grid-cols-3 gap-2">
              <Stat icon={Eye} label="Opens" value={stats.opens} testId="gb-stat-opens" />
              <Stat icon={Eye} label="Last 30d" value={stats.opens_30d} testId="gb-stat-opens-30d" />
              <Stat icon={Users} label="Guests" value={stats.unique_visitors} testId="gb-stat-visitors" />
            </div>
            {stats.sections.length === 0 ? (
              <p className="text-xs text-slate-500" data-testid="gb-stats-empty">No section taps yet. Stats appear as guests scan the QR code and open sections.</p>
            ) : (
              <div className="space-y-1.5" data-testid="gb-stats-sections">
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Most tapped sections</p>
                {stats.sections.slice(0, 6).map((s) => (
                  <div key={s.section} data-testid={`gb-stat-section-${s.section}`} className="text-xs">
                    <div className="flex justify-between text-slate-700"><span className="truncate">{sectionLabel(s.section, gb)}</span><span className="font-medium ml-2">{s.count}</span></div>
                    <div className="h-1.5 bg-slate-100 rounded mt-0.5"><div className="h-1.5 bg-amber-500 rounded" style={{ width: `${Math.max(6, (s.count / max) * 100)}%` }} /></div>
                  </div>
                ))}
              </div>
            )}
            {stats.last_open && <p className="text-[11px] text-slate-400">Last opened {new Date(stats.last_open).toLocaleString()}</p>}
          </>
        )}
      </CardContent>
    </Card>
  );
};
